import { __assign } from "tslib";
import { BSSBackendConnector } from "@main/core/bss-connector/backend-connector";
import { concat } from 'lodash';
var correlationId = getCorrelationId();
/**
 * Gets TngaDataLayerT and add default product array if it not exists.
 * @returns TngaDataLayerT
 */
function getTngaDataLayer() {
    if (!window['tngaDataLayer'])
        window['tngaDataLayer'] = {};
    var dataLayer = window['tngaDataLayer'];
    if (!dataLayer.product) {
        dataLayer.product = [];
    }
    return dataLayer;
}
/**
 * Gets 'cars' category in product array.
 * @returns TngaDataLayerT
 */
function findCarCategory(dataLayer) {
    return dataLayer.product.find(function (el) { return el.category === 'cars'; });
}
function getCorrelationId() {
    var correlationId = sessionStorage.getItem('BSS_GA_KEY');
    if (!correlationId) {
        correlationId = BSSBackendConnector.keyGenerator();
        sessionStorage.setItem('BSS_GA_KEY', correlationId);
    }
    return correlationId;
}
/**
 * Provide _productName value to resultData, if there not value then try get it from layoutTexts.
 */
function productNameUpdate(resultData, initialData, key) {
    var _a;
    if (key === void 0) { key = 'productCustomName'; }
    if (!(resultData === null || resultData === void 0 ? void 0 : resultData._productName)) {
        var productName = '';
        var productTexts = initialData.layoutTexts[resultData === null || resultData === void 0 ? void 0 : resultData.productId] || null;
        // for BC
        var variantsList = (resultData === null || resultData === void 0 ? void 0 : resultData.variantsList) || null;
        if (key &&
            resultData &&
            (resultData[key] || resultData['productCustomName'])) {
            productName = resultData[key] || resultData['productCustomName'];
        }
        else if (productTexts && ((_a = Object.keys(productTexts)) === null || _a === void 0 ? void 0 : _a.length)) {
            productName =
                productTexts.product_product_name ||
                    productTexts.product_name ||
                    productTexts.customName;
        }
        else if (variantsList && variantsList.length) {
            productName = variantsList[0].productName || '';
        }
        if (productName) {
            resultData._productName = productName;
        }
    }
    return resultData._productName;
}
/**
 * tngaDataLayer worflowevent data on step navigation change in Online Approval.
 */
function oaElementChangeEvent(_a) {
    var correlationId = _a.correlationId, label = _a.label, resultData = _a.resultData, settings = _a.settings, _b = _a.conversion, conversion = _b === void 0 ? '0' : _b, _c = _a.monthlyfee, monthlyfee = _c === void 0 ? '' : _c;
    financeEvent({
        correlationId: correlationId,
        pushEventName: 'worflowevent',
        resultData: resultData,
        settings: settings,
        event: {
            name: 'workflowevent',
            componentName: 'finance-calculator',
            componentGroup: 'finance',
            action: 'fc-workflow',
            label: label,
        },
        workflow: {
            name: 'finance-approval',
            step: label,
            conversion: conversion,
        },
        monthlyfee: monthlyfee || valueToCurrency(resultData.monthlyPayment),
        duration: resultData.duration,
        currencyCode: 'eur',
    });
}
/**
 * Default tngaDataLayer event/workflow data on initialization.
 */
function initElementEvent(_a, resultData) {
    var _b;
    var _c = _a.correlationId, correlationId = _c === void 0 ? getCorrelationId() : _c, _d = _a.componentName, componentName = _d === void 0 ? 'finance-calculator' : _d, _e = _a.name, name = _e === void 0 ? 'finance-calculator' : _e, _f = _a.label, label = _f === void 0 ? 'configure-product' : _f, _g = _a.action, action = _g === void 0 ? 'fc-workflow' : _g, _h = _a.currencyCode, currencyCode = _h === void 0 ? 'eur' : _h, _j = _a.eventName, eventName = _j === void 0 ? 'finstepevent' : _j, _k = _a.isCompareFinance, isCompareFinance = _k === void 0 ? false : _k;
    var dataLayer = getTngaDataLayer();
    var event = {
        name: eventName,
        componentName: componentName,
        componentGroup: 'finance',
        action: action,
        label: label,
    };
    var workflow = {
        name: name,
        step: label,
        conversion: '0',
    };
    dataLayer.event = event;
    dataLayer.workflow = workflow;
    var settings = generateSettings(resultData);
    if (isCompareFinance) {
        dataLayerPush(eventName, { correlationId: correlationId, event: event, workflow: workflow });
        return;
    }
    financeEvent({
        correlationId: correlationId,
        pushEventName: eventName,
        resultData: resultData,
        settings: settings,
        event: event,
        workflow: workflow,
        monthlyfee: valueToCurrency(resultData === null || resultData === void 0 ? void 0 : resultData.monthlyPayment),
        duration: (_b = resultData === null || resultData === void 0 ? void 0 : resultData.duration) !== null && _b !== void 0 ? _b : resultData === null || resultData === void 0 ? void 0 : resultData.terms,
        currencyCode: currencyCode
    }, false);
}
/**
 * Generate settings section.
 */
export function generateSettings(resultData) {
    var prepareAdditionalServicesSettings = function (services, servicesSettings) {
        if (servicesSettings === void 0) { servicesSettings = []; }
        services.forEach(function (service) {
            var _a = service || {}, values = _a.values, component_code = _a.component_code, checked = _a.checked;
            servicesSettings.push({
                calculationname: "additionalService_".concat(component_code),
                currentvalue: checked.toString(),
            });
            if (values && Array.isArray(values) && values.length) {
                prepareAdditionalServicesSettings(values, servicesSettings);
            }
        });
        return servicesSettings;
    };
    var keysConfig = [
        { keys: ['monthlyPayment'], calculationname: 'monthlyfee', useCurrency: true },
        { keys: ['duration'], calculationname: 'duration', useCurrency: false },
        { keys: ['downpayment'], calculationname: 'downpayment', useCurrency: true },
        { keys: ['mileage'], calculationname: 'mileage', useCurrency: false },
        { keys: ['contractMileage'], calculationname: 'mileage', useCurrency: false },
        { keys: ['balloon', 'balloonPayment'], calculationname: 'balloon', useCurrency: false },
        { keys: ['residualValue', 'rv'], calculationname: 'residualValue', useCurrency: false },
        { keys: ['calculationType'], calculationname: 'calculationType', useCurrency: false },
        { keys: ['term'], calculationname: 'term', useCurrency: false },
        { keys: ['deposit'], calculationname: 'deposit', useCurrency: false },
        { keys: ['finalPayment'], calculationname: 'finalPayment', useCurrency: false },
        { keys: ['repurchase'], calculationname: 'repurchase', useCurrency: false },
        { keys: ['balloonPaymentPercentage'], calculationname: 'balloonPaymentPercentage', useCurrency: false },
        { keys: ['autoInsuranceSelected'], calculationname: 'autoInsurance', useCurrency: false },
        { keys: ['carInsuranceSelected'], calculationname: 'carInsurance', useCurrency: false },
        { keys: ['carInsuranceName'], calculationname: 'carInsuranceName', useCurrency: false },
        { keys: ['livingBudapestSelected'], calculationname: 'livingInBudapest', useCurrency: false },
        { keys: ['livingBudapestSelected'], calculationname: 'livingInBudapest', useCurrency: false },
        { keys: ['rentalsInAdvance'], calculationname: 'rentalsInAdvance', useCurrency: false },
        { keys: ['maintainedSelected'], calculationname: 'maintained', useCurrency: false },
        { keys: ['isPrivateCustomer'], calculationname: 'isPrivateCustomer', useCurrency: false },
        { keys: ['maintenanceSelected', 'maintenanceChecked', 'maintenanceCostSelected'], calculationname: 'maintenance', useCurrency: false },
        { keys: ['gapInsuranceValue', 'gapInsuranceSelected'], calculationname: 'gapInsurance', useCurrency: false },
        { keys: ['lifeInsuranceValue', 'lifeInsuranceSelected'], calculationname: 'lifeInsurance', useCurrency: false },
        { keys: ['extendedWarantyChecked', 'extendedWarrantyChecked'], calculationname: 'extendedWarranty', useCurrency: false },
        { keys: ['customerType'], calculationname: 'customerType', useCurrency: false },
        { keys: ['civilInsuranceType'], calculationname: 'civilInsuranceType', useCurrency: false },
        { keys: ['civilInsuranceLimit'], calculationname: 'civilInsuranceLimit', useCurrency: false },
        { keys: ['accidentInsuranceType'], calculationname: 'accidentInsuranceType', useCurrency: false },
        { keys: ['accidentInsuranceParticipation'], calculationname: 'accidentInsuranceParticipation', useCurrency: false },
        { keys: ['glassInsuranceLimit'], calculationname: 'glassInsuranceLimit', useCurrency: false },
        { keys: ['insurance', 'insuranceSelected', 'insuranceCheckboxSelected'], calculationname: 'insurance', useCurrency: false },
        { keys: ['maintenancePlus'], calculationname: 'maintenancePlus', useCurrency: false, condition: function () { return resultData.maintenancePlus !== '-1'; } },
        { keys: ['extraWarrantyChecked'], calculationname: 'extraWarranty', useCurrency: false },
        { keys: ['interestRateTypeSelected'], calculationname: 'interestRateType', useCurrency: false },
        {
            keys: ['insuranceMonthlyPayment'], calculationname: 'insuranceMonthlyPayment', useCurrency: false, transform: function (insuranceMonthlyPayment) {
                return insuranceMonthlyPayment === '-1' ? '0' : insuranceMonthlyPayment;
            }
        },
        { keys: ['insuranceSelected'], calculationname: 'insuranceCalculated', useCurrency: false },
        { keys: ['birthDate'], calculationname: 'birthDate', useCurrency: false },
        { keys: ['deductibleValue'], calculationname: 'deductible', useCurrency: false, condition: function () { return resultData.deductibleValue !== '-1'; } },
        { keys: ['deductible1Service1Selected'], calculationname: 'deductible1Service1', useCurrency: false, condition: function () { return resultData.deductibleValue !== '-1'; } },
        { keys: ['deductible1Service2Selected'], calculationname: 'deductible1Service2', useCurrency: false, condition: function () { return resultData.deductibleValue !== '-1'; } },
        { keys: ['deductible1Service3Selected'], calculationname: 'deductible1Service3', useCurrency: false, condition: function () { return resultData.deductibleValue !== '-1'; } },
        { keys: ['deductible2Service1Selected'], calculationname: 'deductible2Service1', useCurrency: false, condition: function () { return resultData.deductibleValue !== '-1'; } },
        { keys: ['deductible2Service2Selected'], calculationname: 'deductible2Service2', useCurrency: false, condition: function () { return resultData.deductibleValue !== '-1'; } },
        { keys: ['deductible2Service3Selected'], calculationname: 'deductible2Service3', useCurrency: false, condition: function () { return resultData.deductibleValue !== '-1'; } },
        { keys: ['maintenanceType'], calculationname: 'maintenanceType', useCurrency: false },
        { keys: ['maintExtrasNoutoSelected'], calculationname: 'maintExtrasNouto', useCurrency: false },
        { keys: ['maintExtrasKausivaihtoSelected'], calculationname: 'maintExtrasKausivaihto', useCurrency: false },
        { keys: ['maintExtrasKausisailytysSelected'], calculationname: 'maintExtrasKausisailytys', useCurrency: false },
        { keys: ['maintExtrasSubstituteSelected'], calculationname: 'maintExtrasSubstitute', useCurrency: false },
        { keys: ['maintExtrasNationalSelected'], calculationname: 'maintExtrasNational', useCurrency: false },
        { keys: ['maintExtrasAirconSelected'], calculationname: 'maintExtrasAircon', useCurrency: false },
        { keys: ['maintExtrasTyrechangeSelected'], calculationname: 'maintExtrasTyrechange', useCurrency: false },
        { keys: ['ftInsuranceCostSelected'], calculationname: 'ftInsurance', useCurrency: false },
        { keys: ['ftInsuranceKaskoCostSelected'], calculationname: 'ftInsuranceKasko', useCurrency: false },
        { keys: ['ftInsuranceRestartCostSelected'], calculationname: 'ftInsuranceRestart', useCurrency: false },
        { keys: ['withIncomes'], calculationname: 'withIncomes', useCurrency: false },
        { keys: ['cascoInsurance'], calculationname: 'cascoInsurance', useCurrency: false },
        { keys: ['cascoInsuranceName'], calculationname: 'cascoInsuranceName', useCurrency: false },
        { keys: ['cascoInsuranceTermSelected'], calculationname: 'cascoInsuranceTerm', useCurrency: false },
        { keys: ['lifeInsuranceName'], calculationname: 'lifeInsuranceName', useCurrency: false },
        { keys: ['lifeInsuranceTermSelected'], calculationname: 'lifeInsuranceTerm', useCurrency: false },
        { keys: ['loan2'], calculationname: 'loan2', useCurrency: false },
        { keys: ['monthlyPayment2'], calculationname: 'monthlyfee2', useCurrency: true },
    ];
    var settings = keysConfig
        .map(function (_a) {
        var keys = _a.keys, calculationname = _a.calculationname, useCurrency = _a.useCurrency, condition = _a.condition, transform = _a.transform;
        if (condition && !condition())
            return null;
        var foundKey = keys.find(function (key) { return resultData[key] != null; });
        if (!foundKey)
            return null;
        var rawValue = resultData[foundKey];
        var currentvalue;
        if (transform) {
            currentvalue = transform(rawValue);
        }
        else {
            currentvalue = useCurrency ? valueToCurrency(rawValue) : rawValue;
        }
        return {
            calculationname: calculationname,
            currentvalue: currentvalue
        };
    })
        .filter(Boolean);
    var additionalServices = resultData.additionalServices;
    if (additionalServices && typeof additionalServices === 'string') {
        try {
            var services = JSON.parse(additionalServices);
            if (Array.isArray(services) && services.length) {
                var servicesSettings = prepareAdditionalServicesSettings(services);
                settings = concat(settings, servicesSettings);
            }
        }
        catch (e) {
            console.warn('Invalid JSON in additionalServices:', additionalServices);
        }
    }
    return settings;
}
/**
 * Default tngaDataLayer event/workflow resultData on event.
 */
function componentChangeEvent(resultData, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.componentName, componentName = _d === void 0 ? 'finance-calculator' : _d, _e = _c.name, name = _e === void 0 ? 'finance-calculator' : _e, _f = _c.taggingTriggerName, taggingTriggerName = _f === void 0 ? '' : _f, _g = _c.action, action = _g === void 0 ? '' : _g, _h = _c.label, label = _h === void 0 ? '' : _h, _j = _c.conversion, conversion = _j === void 0 ? '' : _j, _k = _c.currencyCode, currencyCode = _k === void 0 ? 'eur' : _k;
    var _l = resultData.triggerName, triggerName = _l === void 0 ? '' : _l;
    // Change the name of property bound to the component (BE property) to custom name according to business specification if it is in taggingTriggerName
    var defaultLabel = "quotation-completed/".concat(taggingTriggerName || triggerName).replace(/selected|checked|checkboxSelected/gi, '');
    var defaultAction = 'fc-workflow';
    var defaultConversion = '1';
    var dataLayer = getTngaDataLayer();
    var event = {
        name: 'finstepevent',
        componentName: componentName,
        componentGroup: 'finance',
        action: action || defaultAction,
        label: label || defaultLabel,
    };
    var workflow = {
        name: name,
        step: label || defaultLabel,
        conversion: conversion || defaultConversion,
    };
    dataLayer.event = event;
    dataLayer.workflow = workflow;
    var settings = generateSettings(resultData);
    financeEvent({
        correlationId: correlationId,
        pushEventName: 'finstepevent',
        resultData: resultData,
        settings: settings,
        event: event,
        workflow: workflow,
        monthlyfee: valueToCurrency(resultData.monthlyPayment),
        duration: (_b = resultData.duration) !== null && _b !== void 0 ? _b : resultData.terms,
        currencyCode: currencyCode
    }, false);
    //dataLayerPush('workflowevent', { correlationId, event, workflow });
}
/**
 * Default tngaDataLayer event/workflow resultData on productChange.
 */
function productChangeEvent(_a) {
    var _b = _a.resultData, resultData = _b === void 0 ? {} : _b, _c = _a.componentName, componentName = _c === void 0 ? 'finance-calculator' : _c, _d = _a.action, action = _d === void 0 ? 'fc-action' : _d, _e = _a.actionWorkflow, actionWorkflow = _e === void 0 ? 'fc-workflow' : _e, _f = _a.customLabel, customLabel = _f === void 0 ? null : _f, _g = _a.withInit, withInit = _g === void 0 ? true : _g;
    var dataLayer = getTngaDataLayer();
    var label = customLabel !== null && customLabel !== void 0 ? customLabel : "select-product-".concat(resultData === null || resultData === void 0 ? void 0 : resultData._productName);
    var event = {
        name: 'componentevent',
        componentName: componentName,
        componentGroup: 'finance',
        action: action,
        label: label
    };
    dataLayer.event = event;
    dataLayerPush('componentevent', { correlationId: correlationId, event: event });
    if (withInit)
        initElementEvent({
            label: 'configure-product',
            componentName: componentName,
            name: componentName,
            action: actionWorkflow,
        }, resultData);
}
/**
 * Default tngaDataLayer event/workflow data on closeElement.
 */
function closeElementEvent(componentName) {
    if (componentName === void 0) { componentName = 'finance-calculator'; }
    var dataLayer = getTngaDataLayer();
    var event = {
        name: 'componentevent',
        componentName: componentName,
        componentGroup: 'finance',
        action: 'click-function',
        label: 'close-panel',
    };
    dataLayer.event = event;
    dataLayerPush('componentevent', { correlationId: correlationId, event: event });
}
/**
 * Default tngaDataLayer event/workflow/productInfo/finance data on closeAndSaveElement.
 */
function closeAndSaveElementEvent(resultData, settings, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.componentName, componentName = _d === void 0 ? 'finance-calculator' : _d, _e = _c.name, name = _e === void 0 ? 'finance-calculator' : _e, _f = _c.currencyCode, currencyCode = _f === void 0 ? 'eur' : _f, _g = _c.action, action = _g === void 0 ? 'fc-workflow' : _g;
    financeEvent({
        correlationId: correlationId,
        pushEventName: 'fincalcevent',
        resultData: resultData,
        settings: settings,
        event: {
            name: 'fincalcevent',
            componentName: componentName,
            componentGroup: 'finance',
            action: action,
            label: 'quotation-confirmed',
        },
        workflow: {
            name: name,
            step: 'quotation-confirmed',
            conversion: '0',
        },
        monthlyfee: valueToCurrency(resultData.monthlyPayment),
        duration: (_b = resultData.duration) !== null && _b !== void 0 ? _b : resultData.terms,
        currencyCode: currencyCode,
    });
}
/**
 * Event triggered on button/accordion click
 */
function clickComponentEvent(label, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.componentName, componentName = _c === void 0 ? 'finance-calculator' : _c, _d = _b.action, action = _d === void 0 ? 'click-function' : _d, _e = _b.name, name = _e === void 0 ? 'componentevent' : _e;
    var dataLayer = getTngaDataLayer();
    var event = {
        name: name,
        componentName: componentName,
        componentGroup: 'finance',
        action: action,
        label: label,
    };
    dataLayer.event = event;
    dataLayerPush(name, { correlationId: correlationId, event: event });
}
function clickButtonOnProductComparisonEvent(label, _a) {
    var _b = _a.name, name = _b === void 0 ? 'componentevent' : _b, _c = _a.componentName, componentName = _c === void 0 ? 'finance-table' : _c, _d = _a.componentGroup, componentGroup = _d === void 0 ? 'product-general' : _d, _e = _a.action, action = _e === void 0 ? 'click-product' : _e;
    var event = {
        name: name,
        componentName: componentName,
        componentGroup: componentGroup,
        action: action,
        label: label,
    };
    var dataLayer = getTngaDataLayer();
    dataLayer.event = event;
    dataLayerPush('componentevent', { correlationId: correlationId, event: event }, false, null);
}
/**
 * Default tngaDataLayer event, product, workflow, filter data on model selected on BC.
 */
function clickBCModelSelectedEvent(label, _a, car, filter) {
    var _b;
    var _c = _a.componentName, componentName = _c === void 0 ? 'budget-calculator/inpage' : _c, _d = _a.action, action = _d === void 0 ? 'tool-workflow' : _d, _e = _a.conversion, conversion = _e === void 0 ? '0' : _e;
    var dataLayer = getTngaDataLayer();
    // event object
    var event = {
        name: 'workflowevent',
        componentName: componentName,
        componentGroup: 'finance',
        action: action,
        label: label,
    };
    // workflow object
    var workflow = {
        name: 'budget-calculator',
        step: label,
        conversion: conversion,
    };
    dataLayer.event = event;
    dataLayer.workflow = workflow;
    // product object
    var product = new Array();
    var carIndex = (_b = dataLayer.product) === null || _b === void 0 ? void 0 : _b.findIndex(function (el) { return el.category === 'cars'; });
    product.push(car);
    if (carIndex !== -1) {
        dataLayer.product[carIndex] = car;
    }
    else {
        dataLayer.product.push(car);
    }
    // filter object
    dataLayer.filter = filter;
    dataLayerPush('workflowevent', { correlationId: correlationId, event: event, product: product, workflow: workflow, filter: filter }, false, null);
}
/**
 * Default tngaDataLayer event/workflow/product/finance/filter data on budgetevent (CTA actions) on BC.
 */
function clickBCBudgetEvent(label, _a, _b, resultData, sendTaggingFinished) {
    var _c = _a === void 0 ? {} : _a, _d = _c.componentName, componentName = _d === void 0 ? 'budget-calculator/inpage' : _d, _e = _c.action, action = _e === void 0 ? 'click-carconfigurator' : _e, _f = _c.step, step = _f === void 0 ? 'click-carconfigurator' : _f, _g = _c.currencyCode, currencyCode = _g === void 0 ? 'eur' : _g;
    var _h = _b === void 0 ? {} : _b, _j = _h.settings, settings = _j === void 0 ? new Array() : _j, _k = _h.tagCar, tagCar = _k === void 0 ? {} : _k, _l = _h.tagFilter, tagFilter = _l === void 0 ? new Array() : _l, _m = _h.monthlyfee, monthlyfee = _m === void 0 ? '' : _m, _o = _h.duration, duration = _o === void 0 ? '' : _o;
    if (sendTaggingFinished === void 0) { sendTaggingFinished = false; }
    // event object
    var event = {
        name: 'budgetevent',
        componentName: componentName,
        componentGroup: 'finance',
        action: action,
        label: label,
    };
    // workflow object
    var workflow = {
        name: 'budget-calculator',
        step: step,
        conversion: '1',
    };
    financeEvent({
        correlationId: correlationId,
        pushEventName: 'budgetevent',
        resultData: resultData,
        settings: settings,
        event: event,
        workflow: workflow,
        monthlyfee: monthlyfee,
        duration: duration,
        currencyCode: currencyCode,
        tagCar: tagCar,
        tagFilter: tagFilter
    }, sendTaggingFinished);
}
/**
 * tngaDataLayer event/workflow/product/finance with finance data.
 */
function financeEvent(_a, sendTaggingFinished, isSaveAndClose) {
    var _b, _c, _d, _e;
    var correlationId = _a.correlationId, pushEventName = _a.pushEventName, resultData = _a.resultData, settings = _a.settings, event = _a.event, workflow = _a.workflow, monthlyfee = _a.monthlyfee, duration = _a.duration, currencyCode = _a.currencyCode, _f = _a.tagCar, tagCar = _f === void 0 ? {} : _f, _g = _a.tagFilter, tagFilter = _g === void 0 ? new Array() : _g;
    if (sendTaggingFinished === void 0) { sendTaggingFinished = false; }
    if (isSaveAndClose === void 0) { isSaveAndClose = true; }
    var dataLayer = getTngaDataLayer();
    // PRODUCT CAR DATA
    var product = new Array();
    var isCarProduct = tagCar && Object.keys(tagCar).length;
    var carIndex = (_b = dataLayer.product) === null || _b === void 0 ? void 0 : _b.findIndex(function (el) { return el.category === 'cars'; });
    if (isCarProduct && dataLayer.product) {
        product.push(tagCar);
        if (carIndex !== -1) {
            dataLayer.product[carIndex] = tagCar;
        }
        else {
            dataLayer.product.push(tagCar);
        }
    }
    // PRODUCT SERVICE DATA
    var serviceIndex = (_c = dataLayer.product) === null || _c === void 0 ? void 0 : _c.findIndex(function (el) { return el.category === 'services'; });
    var productInfo = {
        productName: (_d = resultData === null || resultData === void 0 ? void 0 : resultData._productName) !== null && _d !== void 0 ? _d : resultData === null || resultData === void 0 ? void 0 : resultData.customName,
        monthlyfee: monthlyfee,
        currencyCode: currencyCode,
    };
    var service = {
        category: 'services',
        subCategory: 'finance',
        productInfo: productInfo,
    };
    product.push(service);
    if (serviceIndex !== -1 && dataLayer.product) {
        dataLayer.product[serviceIndex] = service;
    }
    else if (dataLayer.product) {
        dataLayer.product.push(service);
    }
    if (isSaveAndClose === false) {
        delete dataLayer['product'];
    }
    // FINANCE DATA
    var finance = {
        products: [
            __assign(__assign({}, productInfo), { duration: duration }),
        ],
        settings: settings,
    };
    dataLayer.event = event;
    dataLayer.workflow = workflow;
    dataLayer.finance = finance;
    // FILTER DATA
    var isFilter = tagFilter === null || tagFilter === void 0 ? void 0 : tagFilter.length;
    if (isFilter) {
        dataLayer.filter = tagFilter;
    }
    var pushEventValue = {
        correlationId: correlationId,
        event: event,
        workflow: workflow,
        finance: finance,
        product: product,
    };
    if (isFilter) {
        pushEventValue.filter = tagFilter;
    }
    if (isSaveAndClose === false) {
        delete pushEventValue['product'];
    }
    var entity = ((_e = resultData.entity) === null || _e === void 0 ? void 0 : _e[0]) || null;
    dataLayerPush(pushEventName, pushEventValue, sendTaggingFinished, entity);
}
/**
 * Return value from object array [{name: 'key', value: ... }]
 * @param componentArray
 * @param key
 * @returns string
 */
function getComponentValue(componentArray, key) {
    var _a;
    return ((_a = componentArray.find(function (el) { return el.name == key; })) === null || _a === void 0 ? void 0 : _a.value) || '-';
}
/**
 * Trigger event when tngaDataLayer is changed.
 * @param eventName
 * @param eventData
 */
function dataLayerPush(eventName, eventData, sendTaggingFinished, entity) {
    if (sendTaggingFinished === void 0) { sendTaggingFinished = false; }
    if (entity === void 0) { entity = null; }
    if (window['bssOrigin'] === 'apheleia-carconfig') {
        if (eventData.workflow)
            eventData.workflow.source = 'apheleia-build';
        window['tngaDataLayer'].workflow.source = 'apheleia-build';
    }
    else {
        if (eventData.workflow)
            eventData.workflow.source = 'build';
        window['tngaDataLayer'].workflow.source = 'build';
    }
    if (!window['dataLayer'])
        window['dataLayer'] = [];
    window['dataLayer'].push({ event: eventName });
    if (localStorage.getItem('BSS_DXP_TAGGING')) {
        console.log('DXP_TAGGING_EVENT: ', eventData);
        //console.log('DXP_TNGA_DATALAYER: ', window['tngaDataLayer']); - uncomment when QA automatic tests are rdy for it 
        window.dispatchEvent(new Event("dxp-".concat(eventName)));
        if (sendTaggingFinished && entity) {
            // send finished tagging event only for entity purposes
            entity.dispatchEvent(new Event('dxp-tagging-finished', { bubbles: false }));
        }
    }
}
var _currencyFormatter = Intl.NumberFormat('en-US', {
    useGrouping: false,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
/**
 * Convert value to currency. All currency / float values should apply the following format i.e.
 ○ No thousand separator
 ○ Decimal must be represented by a “.” (dot) as in American format
 ○ For currency value, no currency symbol
 * @param {String|Number} [value=null] value to format
 */
function valueToCurrency(value) {
    if (typeof value == 'string') {
        _currencyFormatter.format(parseFloat(value));
    }
    return _currencyFormatter.format(value);
}
/**
 * Convert any value to boolean, with string support
 ○ "false" => false
 ○ "0" => false
 ○ "demo" => true
 * @param {any} [value=null]
 */
function valueToBoolean(value) {
    if (typeof value == 'string' &&
        (parseInt(value) === 0 || value.toLowerCase() === 'false')) {
        return false;
    }
    return !!value;
}
/**
 * Return settings object
 */
function settingsValue(calculationname, currentvalue, currency) {
    if (currency === void 0) { currency = false; }
    var value = currentvalue || '';
    return {
        calculationname: calculationname,
        currentvalue: currency ? valueToCurrency(value) : value,
    };
}
export { valueToCurrency, valueToBoolean, dataLayerPush, productNameUpdate, initElementEvent, closeElementEvent, closeAndSaveElementEvent, productChangeEvent, componentChangeEvent, oaElementChangeEvent, getComponentValue, getTngaDataLayer, findCarCategory, clickComponentEvent, clickBCBudgetEvent, clickBCModelSelectedEvent, settingsValue, getCorrelationId, clickButtonOnProductComparisonEvent, };
